import { PdvService } from './../../services/pdv/pdv.service';
import { WebSiteUsersService } from './../../services/webSiteUsers/webSiteUsers.service';
import { ToastrService } from 'ngx-toastr';
import { Component, Output, EventEmitter } from '@angular/core';
import { localStorageService } from '@app/services/localStorage/localStorage.service';
import { AuthService } from '@app/modules/angular-6-social-login-master';
import { Router } from '@angular/router';
@Component({
    moduleId: module.id,
    selector: 'checkout-authentification',
    templateUrl: 'checkout-authentification.component.html',
    styleUrls: ['checkout-authentification.component.scss'],
    providers: [AuthService]
})
export class CheckoutAuthentificationComponent {
    user: any = {
        lastname: "",
        phone: "",
        email: "",
        password: "",
        confirmePassword: "",
        pdv: ""
    }
    loader: boolean = false;
    step = 1;
    @Output()
    onNext: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output()
    onBack: EventEmitter<boolean> = new EventEmitter<boolean>();
    disp = false;
    stepPhone = 1;
    socialProvider = "";
    idToken = "";
    phone = "";
    constructor(
        private toastr: ToastrService,
        private webSiteUsersService: WebSiteUsersService,
        private pdvService: PdvService,
        private localStorage: localStorageService,
        public OAuth: AuthService,
        private router: Router
    ) {
        this.user.pdv = this.pdvService.idPdv;
    }


    signIn(provider) {
        this.OAuth.signIn(provider).then(socialusers => {
            console.log(socialusers)
            this.socialProvider = provider;
            this.idToken = (provider == 'facebook') ? socialusers.token : socialusers.idToken;
            let clientId = (provider == 'facebook') ? PdvService.facebookId : PdvService.googleId;
            this.signInWithSocial({ clientId, provider, idToken: this.idToken })
        });
    }

    signInWithSocial(params) {
        this.webSiteUsersService.signInWithSocial(params).subscribe(
            (data: any) => {
                this.localStorage.setItem({ key: 'token', value: data.token });
                this.webSiteUsersService.listener.next(true);
                this.loader = false;
                this.onNext.emit(true);
            },
            (err: any) => {
                if (err.status == 400 && err.error.code == 1) {
                    this.stepPhone = 2;
                } else {
                    this.toastr.error('Code : ' + err.status, 'Erreur Serveur');
                }
            }
        )
    }
    valide() {
        if (!this.phone.match(/^\d{10}$/)) {
            this.toastr.error('Merci de saisir un numèro valide', 'Attention !');
            this.loader = false;
        } else {
            let clientId = (this.socialProvider == 'facebook') ? PdvService.facebookId : PdvService.googleId;
            this.signInWithSocial({ clientId, provider: this.socialProvider, idToken: this.idToken, phone: this.phone })
        }
    }


    signup() {
        if (this.user.lastname.trim() == '' || this.user.email.trim() == '' || this.user.phone.trim() == '' || this.user.password.trim() == '' || this.user.confirmePassword.trim() == '') {
            this.toastr.error('Merci de remplir tous les champs', 'Attention !');
        } else {
            if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.user.email))) {
                this.toastr.error('Merci de saisir une adresse email valide', 'Attention !');
            } else {
                if (!this.user.phone.match(/^\d{10}$/)) {
                    this.toastr.error('Merci de saisir un numèro valide', 'Attention !');
                } else {
                    if (this.user.password.trim().length < 8) {
                        this.toastr.error('mot de passe invalide minimum 8 caractères ', 'Attention !');
                    } else {
                        if (this.user.password !== this.user.confirmePassword) {
                            this.toastr.error('les mots de passe saisis ne sont pas identiques', 'Attention !');
                        } else {
                            this.loader = true;
                            this.webSiteUsersService.addCustomer(this.user).subscribe(
                                (data: any) => {
                                    this.localStorage.setItem({ key: 'token', value: data.token });
                                    this.webSiteUsersService.listener.next(true);
                                    this.loader = false;
                                    this.onNext.emit(true);
                                    this.toastr.success('Merci de consulter votre boite email pour valider votre inscription.', 'Success !');
                                }, (err: any) => {
                                    this.loader = false;
                                    if (err.status == 409) {
                                        this.toastr.error('Ce compte existe déja', 'Attention !');
                                    } else {
                                        this.toastr.error('Erreur ' + err.status, 'Erreur !');
                                    }
                                }
                            )
                        }
                    }
                }
            }
        }
    }

    login() {
        if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.user.email))) {
            this.toastr.error('Merci de saisir une adresse email valide', 'Attention !');
        } else {
            if (this.user.password.trim().length < 8) {
                this.toastr.error('Merci de saisir le mot de passe', 'Attention !');
            } else {
                this.loader = true;
                this.webSiteUsersService.login({ email: this.user.email, password: this.user.password, pdv: this.user.pdv }).subscribe(
                    (data: any) => {
                        this.localStorage.setItem({ key: 'token', value: data.token });
                        this.webSiteUsersService.listener.next(true);
                        this.loader = false;
                        this.onNext.emit(true);
                    }, (err: any) => {
                        this.loader = false;
                        if (err.status == 400) {
                            this.toastr.error("l'adresse email ou mot de passe incorrect", 'Attention !');
                        } else {
                            this.toastr.error('Erreur ' + err.status, 'Erreur !');
                        }
                    }
                )
            }
        }
    }

    sendPassword() {
        if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.user.email))) {
            this.toastr.error('Merci de saisir une adresse email valide', 'Attention !');
        } else {
            this.loader = true;
            this.webSiteUsersService.forgetPassword(this.user.email).subscribe(
                (data: any) => {
                    if (data.success) {
                        this.toastr.success('Merci de consulter votre boite email pour obtenir votre mot de passe');
                        this.step = 1;
                        this.loader = false;
                    } else {
                        this.toastr.error('Aucun compte correspondant à votre email', 'Attention !');
                        this.loader = false;
                    }
                },
                (err) => {
                    this.loader = false;
                }
            )
        }
    }
    back(i) {
        if (i == 0) {
            this.step = 1;
        } else {
            this.onBack.emit(true);
        }
    }
}
